const jwt_customizer = {
    general: 'Произошла ошибка при настройке JWT-токена. Пожалуйста, попробуйте снова позже.',
    can_not_create_for_admin_tenant: 'Невозможно создать настраиваемый JWT-токен для административного арендатора.',
};
export default Object.freeze(jwt_customizer);
